import React from 'react'
import CountUp from 'react-countup'
import { graphql, useStaticQuery } from 'gatsby'

import {
  Section,
  Container,
  ChoreCountContainer,
  Header,
  Text,
  ImageContainer,
  Count,
  Icon,
} from './styles'

const TOTAL_CHORES_COMPLETED = 275302324
const COUNT_UP_TICKS = 60000

const smoothEasing = (t, b, c, d) => (c * t) / d + b
const Counter = () => {
  const { checkmark } = useStaticQuery(graphql`
    query CounterQuery {
      checkmark: file(relativePath: { eq: "calendar/checkbox-round.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 40, layout: FIXED, placeholder: NONE)
        }
      }
    }
  `)

  return (
    <Section>
      <Container>
        <Header>Bringing families together, one chore at a time.</Header>
        <ChoreCountContainer>
          <ImageContainer>
            <Icon image={checkmark.childImageSharp.gatsbyImageData} alt="checkmark" />
          </ImageContainer>
          <CountUp
            delay={0}
            start={TOTAL_CHORES_COMPLETED - COUNT_UP_TICKS}
            end={TOTAL_CHORES_COMPLETED}
            duration={7}
            separator=","
            decimals={0}
            useEasing
            easingFn={smoothEasing}
            useGrouping
            decimal=","
            preserveValue
          >
            {({ countUpRef }) => <Count ref={countUpRef} />}
          </CountUp>
        </ChoreCountContainer>
        <Text>Chores Completed</Text>
      </Container>
    </Section>
  )
}

export default Counter
